/**
 * Keep in sync with the `RemitMode` enum-source registration in
 * redo/backend/db/schema/src/team/RedoManagedReturnsSettings.ts.
 *
 * Governs *when* an accepted RMR return is remitted, for every processing level.
 * The value `"AUTOMATIC"` is intentionally distinct from
 * `ReturnProcessingLevel.VERIFICATION` (`"verification"`): remit mode is about
 * timing, not which level the merchant runs.
 */
export const RemitMode = { AUTOMATIC: "AUTOMATIC", MANUAL: "manual" } as const;
export type RemitMode = (typeof RemitMode)[keyof typeof RemitMode];
